export class SkyModalDemoContext {
  public valueA: string;
  public eventMessage?: string;
}
